import React from "react";
import { processFrames } from "../data/films";
import { FadeUp } from "./FadeUp";
function Sprockets({
  vertical
}: {
  vertical?: boolean;
}) {
  return <div aria-hidden="true" className={`flex shrink-0 justify-between overflow-hidden ${vertical ? "w-6 flex-col items-center py-3" : "h-6 items-center px-3"}`} data-id="element-100" data-mp="17esvme1jk6z">
      {Array.from({
      length: vertical ? 28 : 44
    }).map((_, i) => <span key={i} className={`shrink-0 rounded-[2px] bg-ink ${vertical ? "h-3 w-2.5 my-1" : "h-2.5 w-3 mx-1"}`} data-id="element-101" data-mp="39lwvv9p4k9jq" data-mpi={i} />)}
    </div>;
}
export function FilmStripProcess() {
  return <section id="process" className="scroll-mt-20 py-20 md:py-28" aria-labelledby="process-heading" data-id="element-102" data-mp="3jirrnku0jvub">
      <div className="container-x" data-id="element-103" data-mp="3oajilwh303kz">
        <FadeUp data-id="element-104" data-mp="3obkws9te966x">
          <h2 id="process-heading" className="font-serif text-[36px] leading-none tracking-[-0.02em] text-white sm:text-[clamp(40px,4.2vw,56px)]" data-id="element-105" data-mp="3oc4htzeccap6">
            How a film gets made
          </h2>
        </FadeUp>

        <FadeUp className="mt-10 md:mt-12" data-id="element-106" data-mp="2vre37pyzgkem">
          <div className="flex overflow-hidden rounded-[20px] bg-card md:flex-col" data-id="element-107" data-mp="poz5k4fy64p1">
            <div className="md:hidden" data-id="element-108" data-mp="kqnu5pa07m4p"><Sprockets vertical data-id="element-109" data-mp="ks8nxcohv11i" /></div>
            <div className="hidden md:block" data-id="element-110" data-mp="kta41vkdadq3"><Sprockets data-id="element-111" data-mp="fzfkqt8oc0rj" /></div>
            <ol className="grid flex-1 grid-cols-1 gap-3 py-3 md:grid-cols-4 md:px-3 md:py-0" data-id="element-112" data-mp="fyml0c84ubiw">
              {processFrames.map((frame, i) => <li key={frame.id} className="flex flex-col" data-id="element-113" data-mp="6z9b5ig3jkxn" data-mpi={i}>
                  <div className="relative aspect-[4/3] overflow-hidden rounded-[12px] bg-ink" data-id="element-114" data-mp="70u7ndlz1dy5">
                    <img src={frame.image} alt={frame.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-115" data-mp="1z4r5ifzc82o" />
                    <span className="absolute left-3 top-3 rounded-[8px] bg-black/60 px-2 py-1 font-mono text-[11px] tracking-[0.12em] text-signal" data-id="element-116" data-mp="3t8tt0ie099zc">
                      FR 0{i + 1}
                    </span>
                  </div>
                  <div className="px-1 pb-2 pt-4" data-id="element-117" data-mp="1mfrn76ij44sx">
                    <h3 className="font-serif text-[22px] leading-none text-white" data-id="element-118" data-mp="1mh2n2v8usser">{frame.title}</h3>
                    <p className="mt-2 text-[13px] leading-relaxed text-body md:text-[14px]" data-id="element-119" data-mp="3gv6q6saede89">{frame.caption}</p>
                  </div>
                </li>)}
            </ol>
            <div className="md:hidden" data-id="element-120" data-mp="36zwroej7joz8"><Sprockets vertical data-id="element-121" data-mp="36wh8azii3ts0" /></div>
            <div className="hidden md:block" data-id="element-122" data-mp="3bwn7d0r3oik4"><Sprockets data-id="element-123" data-mp="3bxy6gn9lp24w" /></div>
          </div>
        </FadeUp>
      </div>
    </section>;
}